export const PUBLIC_NAV = [
  { to: "/beskriv-problem", label: "Opret forespørgsel", testid: "nav-create-request", primary: true },
  { to: "/eksperter", label: "Find hjælp", testid: "nav-find-help" },
  { to: "/tjen-penge-paa-din-viden", label: "Tjen på din viden", testid: "nav-provider-recruitment", quiet: true },
];

export const CUSTOMER_NAV = [
  ...PUBLIC_NAV,
  { to: "/dashboard", label: "Mine forespørgsler", testid: "nav-my-requests", requests: true },
];

const HOW_IT_WORKS_NAV = {
  to: "/#saadan-virker-det",
  label: "Sådan virker det",
  testid: "nav-how-it-works",
  auxiliary: true,
};

export const MOBILE_PUBLIC_NAV = [...PUBLIC_NAV, HOW_IT_WORKS_NAV];

export const MOBILE_CUSTOMER_NAV = [
  ...PUBLIC_NAV,
  { to: "/dashboard", label: "Mine forespørgsler", testid: "nav-my-requests", requests: true },
  HOW_IT_WORKS_NAV,
];

export const EXPERT_PRIMARY = [
  { tab: "overview", label: "Dashboard", testid: "nav-expert-dashboard" },
  { tab: "requests", label: "Forespørgsler", testid: "nav-expert-requests", badge: true },
  { tab: "earnings", label: "Indtjening", testid: "nav-expert-earnings" },
];
